import { render, staticRenderFns } from "./shieldAlertrecord.vue?vue&type=template&id=0cfedf9c&scoped=true&"
import script from "./shieldAlertrecord.vue?vue&type=script&lang=js&"
export * from "./shieldAlertrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfedf9c",
  null
  
)

export default component.exports